import {find} from 'lodash';
import config from '../../app/config';
import {isDesktop} from 'react-device-detect';

export const CENTRAL_PAGE_PATH = '/central';

export const MODULE_NAMES = {
  MESSAGES: "messages",
  APPOINTMENTS: "appointments",
  PATIENTS: "patients",
  PATIENT_DASHBOARD: "patientDashboard",
  ADD_PATIENT: "addPatient",
  PATIENT_FILTERS: "patientFilters",
  CPP_DASHBOARD: "cppDashboard",
  WARD_VIEW: "wardView",
  HOLDING_PEN: "holdingPen",
  SEARCH: "search",
  AUDITS: "audits",
  BED_MANAGEMENT: "bedManagement",
  BED_BOOKING: "bedBooking",
  ADM_WORK_LIST: "admWorkList",
  FHIR_DASHBOARD: "fhirDashboard",
  ADMIN: "admin",
  ADMIT_PATIENT: "admitPatient",
  EXTERNAL_MANAGMENT: "externalManagment",
  EXTERNAL_MANAGMENT_REFRESH: "externalManagmentRefresh",
  REGISTRATION: "registration",
  EXTENDED_DASHBOARD: "extendedDashboard",
  MAIN_VIEW: "mainView",
  BOOK_ADMISSION: "bookAdmission",
  BOOKED_ADMISSION: "bookedAdmission",
  BOOKED_ADMISSIONS_DASHBOARD: "bookedAdmissionDashboard",
  CLEANING_REQUEST: "cleaningRequest",
  ESTIMATED_WAITING_TIME: "estimatedWaitingTime",
  CENTRAL_PAGE: "centralPage",
  SCHEDULER: "scheduler",
  PATIENT_REGISTRY: "patientRegistry",
};

// Move to DB => dict.agyleModules;
export const AVAILABLE_MODULES = [
  {
    id: 'admin',
    name: MODULE_NAMES.ADMIN,
    description: 'Administration',
    componentPath: '/admin',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: config?.adminModuleEnabled,
  },
  // {
  //   id: 'externalManagment',
  //   name: MODULE_NAMES.EXTERNAL_MANAGMENT,
  //   description: 'External Managment',
  //   componentPath: '/eadmit',
  //   devices: ['desktop', 'mobile', 'iPad'],
  //   enabled: config?.externalManagment?.enabled,
  // },
  {
    id: "externalManagmentRefresh",
    name: MODULE_NAMES.EXTERNAL_MANAGMENT_REFRESH,
    description: "ADT",
    componentPath: "/eadmitRefresh",
    devices: ["desktop", "mobile", "iPad"],
    enabled: config?.externalManagment?.enabled,
  },
  // {
  //   id: 'admitPatientNew',
  //   name: MODULE_NAMES.ADMIT_PATIENT,
  //   description: 'Admit Patient',
  //   componentPath: '/admitNew',
  //   devices: ['desktop', 'mobile', 'iPad'],
  //   enabled: config?.admitPatient?.registration,
  // },
  {
    id: 'audits',
    name: MODULE_NAMES.AUDITS,
    description: 'Audit',
    componentPath: '/audits',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: true,
  },
  {
    id: 'bedBooking',
    name: MODULE_NAMES.BED_BOOKING,
    description: 'Flow (Lite)',
    componentPath: '/bedBooking',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: true,
  },
  {
    id: 'bedManagement',
    name: MODULE_NAMES.BED_MANAGEMENT,
    description: 'Flow',
    devices: ['desktop', 'mobile', 'iPad'],
    componentPath: '/bedManagement',
    enabled: config?.modules?.bedManagement?.enabled,
  },
  {
    id: 'bookAdmission',
    name: MODULE_NAMES.BOOK_ADMISSION,
    description: 'Book Admission',
    componentPath: '/bookAdmission',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: config?.bookAdmissionModuleEnabled && isDesktop,
  },
  {
    id: 'bookedAdmissionsDashboard',
    name: MODULE_NAMES.BOOKED_ADMISSIONS_DASHBOARD,
    devices: ['desktop', 'mobile', 'iPad'],
    description: 'Booked Admissions Dashboard',
    componentPath: '/bookedAdmissionsDashboard',
    enabled: config?.bookAdmissionModuleEnabled && isDesktop,
  },
  {
    id: 'cleaningRequest',
    name: MODULE_NAMES.CLEANING_REQUEST,
    devices: ['desktop', 'mobile', 'iPad'],
    description: 'Support Services',
    componentPath: '/report/cleaningRequest',
    enabled: config?.modules?.cleaningRequest?.enabled,
  },
  {
    id: 'estimatedWaitingTime',
    name: MODULE_NAMES.ESTIMATED_WAITING_TIME,
    devices: ['desktop', 'mobile', 'iPad'],
    description: 'ED Wait',
    componentPath: (hospitalId) => `/report/estimatedTime/${hospitalId}`,
    enabled: true,
  },
  {
    id: 'extendedDashboard',
    name: MODULE_NAMES.EXTENDED_DASHBOARD,
    description: 'Insight (Lite)',
    devices: ['desktop', 'mobile', 'iPad'],
    componentPath: '/report/dashboard',
    enabled: config?.modules?.reports?.extendedDashboard,
  },
  {
    id: 'fhirDashboard',
    name: MODULE_NAMES.FHIR_DASHBOARD,
    description: 'FHIR Dashboard',
    componentPath: '/fhirDashboard',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: false,
  },
  {
    id: 'holdingPen',
    name: MODULE_NAMES.HOLDING_PEN,
    description: 'Holding Pen',
    componentPath: '/holding',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: false,
  },
  {
    id: 'mainView',
    name: MODULE_NAMES.MAIN_VIEW,
    description: 'Main View',
    componentPath: '/main',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: config.modules?.map?.customMap,
  },
  {
    id: 'search',
    name: MODULE_NAMES.SEARCH,
    description: 'Smart Search',
    componentPath: '/search',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: true,
  },
  {
    id: 'registration',
    name: MODULE_NAMES.REGISTRATION,
    description: 'Registration',
    componentPath: '/registration',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: false,
  },
  {
    id: "patientRegistry",
    name: MODULE_NAMES.PATIENT_REGISTRY,
    description: "Registration",
    componentPath: "/registry",
    devices: ["desktop", "mobile", "iPad"],
    enabled: config?.admitPatient?.registration,
  },
  {
    id: "patientAppointments",
    name: MODULE_NAMES.SCHEDULER,
    description: "Scheduler",
    componentPath: "/scheduler",
    devices: ["desktop"],
    enabled: config?.modules?.scheduler?.enabled,
  },
  {
    id: "wardView",
    name: MODULE_NAMES.WARD_VIEW,
    description: 'Whiteboard',
    componentPath: '/wards',
    enabled: config?.modules?.wardCreator?.enabled,
    devices: ['desktop', 'mobile', 'iPad'],
  },
  {
    id: 'admWorkList',
    name: MODULE_NAMES.ADM_WORK_LIST,
    description: 'Work List',
    componentPath: '/admWorkList',
    devices: ['desktop', 'mobile', 'iPad'],
    enabled: false,
  },
  {
    id: 'tutorials',
    name: 'tutorials',
    description: 'Resources',
    devices: ['desktop', 'mobile', 'iPad'],
    componentPath: '/training',
    enabled: true,
  },
  {
    id: 'mct',
    name: 'mct',
    description: 'Creator',
    devices: ['desktop', 'iPad'],
    componentPath: '/wards',
    enabled: config?.modules?.wardCreator?.enabled,
  },
];

export const getModulePath = (moduleName) => {
  const module = find(AVAILABLE_MODULES, { name: moduleName });

  if (module) {
    return module.componentPath;
  }

  return CENTRAL_PAGE_PATH;
};

export const MODULE_PATHS = {
  [MODULE_NAMES.SCHEDULER]: `${getModulePath(MODULE_NAMES.SCHEDULER)}`,
  [MODULE_NAMES.PATIENT_REGISTRY]: getModulePath(MODULE_NAMES.PATIENT_REGISTRY),
  [MODULE_NAMES.ESTIMATED_WAITING_TIME]: getModulePath(MODULE_NAMES.ESTIMATED_WAITING_TIME),
};
